import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "shared/Button";
import UpdateBirthdayModal from "shared/modals/UpdateBirthdayModal";

import moment from "moment";

export default function Birthday() {
    const user = useSelector((s) => s.auth.user);
    const [isModalShowing, setIsModalShowing] = useState(false);

    console.log("User: ", user);

    return (
        <>
            <div>
                <p className="gkit-p-20 fw-bold mb-2">Your birthday</p>
                <p className="gkit-p-17 mt-0">
                    {user.birthday
                        ? new Date(user.birthday).toLocaleDateString()
                        : "Not set"}
                </p>
                <Button
                    btnType="white"
                    className="mt-3"
                    onClick={() => setIsModalShowing(true)}
                >
                    Update
                </Button>
            </div>
            <UpdateBirthdayModal
                birthday={
                    user.birthday
                        ? moment(user.birthday).format("DD/MM/YYYY")
                        : ""
                }
                open={isModalShowing}
                onClose={() => setIsModalShowing(false)}
            />
        </>
    );
}
